import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useAppTranslation } from "../TranslationContext";
import s from './Register.module.css';
import { useTranslation } from 'react-i18next'; // i18next

export const Register = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [token, setToken] = useState('');
  const [userId, setUsersId] = useState('');
  const { t } = useAppTranslation();
  const { i18n } = useTranslation();        // для переключения языка в i18next

  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password1: '',
    password2: '',
    first_name: '',
    last_name: '',
    til: '',
    ilmiy_daraja: '',
    otasining_ismi: '',
    description: '',
  });
  

  const [message, setMessage] = useState('');
  const [degrees, setDegrees] = useState([]); // Список учёных степеней

  useEffect(() => {
    // Получаем список степеней при загрузке
    const fetchDegrees = async () => {
      try {
        const res = await fetch('https://api.eduskill.uz/api/ilmiy-darajalar/');
        const data = await res.json();
        setDegrees(data);
      } catch (err) {
        console.error("Ошибка при получении степеней:", err);
      }
    };
    fetchDegrees();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Шаг 1: Регистрация
  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch('https://api.eduskill.uz/api/v1/dj-rest-auth/registration/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          username: formData.username,
          email: formData.email,
          password1: formData.password1,
          password2: formData.password2,
        }),
      });

      let data = {};
      try { data = await res.json(); } catch {}

      if (!res.ok) {
        setMessage(JSON.stringify(data) || `Ошибка сервера: ${res.status}`);
        return;
      }

      // Сервер не вернул токен при регистрации — получаем его через логин
      let tokenValue = data.key ?? data.access ?? data.token ?? '';
      if (!tokenValue) {
        const loginRes = await fetch('https://api.eduskill.uz/api/v1/dj-rest-auth/login/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            username: formData.username,
            password: formData.password1,
          }),
        });
        const loginData = await loginRes.json();
        if (!loginRes.ok) {
          setMessage('Регистрация прошла, но не удалось войти: ' + JSON.stringify(loginData));
          return;
        }
        tokenValue = loginData.key ?? loginData.access ?? loginData.token ?? '';
      }

      if (!tokenValue) {
        setMessage('Не удалось получить токен авторизации');
        return;
      }

      setToken(tokenValue);

      // Получаем ID пользователя — ошибка здесь не прерывает регистрацию
      try {
        const userRes = await fetch('https://api.eduskill.uz/api/v1/dj-rest-auth/user/', {
          headers: { Authorization: `Token ${tokenValue}` },
        });
        const user = await userRes.json();
        if (user?.pk) {
          setUsersId(user.pk);
        } else {
          console.warn("ID пользователя не найден", user);
        }
      } catch (userErr) {
        console.warn("Не удалось получить данные пользователя:", userErr);
      }

      setStep(2);
    } catch (err) {
      setMessage(`Ошибка: ${err.message || err}`);
    }
  };

  // Шаг 2: Обновление first_name, last_name
  const handleUpdateNames = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch('https://api.eduskill.uz/api/v1/dj-rest-auth/user/', {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Token ${token}`,
        },
        body: JSON.stringify({
          first_name: formData.first_name,
          last_name: formData.last_name,
        }),
      });

      if (res.ok) {
        
       
        setStep(3); // Переход к шагу 3
      } else {
        const errData = await res.json();
        setMessage(JSON.stringify(errData));
      }
    } catch {
      setMessage('Ошибка при обновлении имени');
    }
  };

  // Шаг 3: POST профиль
  const handleCreateProfile = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch('https://api.eduskill.uz/api/custom-users/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Token ${token}`,
        },
        body: JSON.stringify({
          user: userId,
          til: Number(formData.til),
          ilmiy_daraja: Number(formData.ilmiy_daraja),
          otasining_ismi: formData.otasining_ismi,
          description: formData.description,
        })
        
      });

      if (res.ok) {
        // Всё успешно
        const user = {
          id: userId, 
          til: formData.til, 
          username: formData.username, 
          first_name: formData.first_name,
          last_name: formData.last_name, 
          email: formData.email
        };
        login({ token, user });
        localStorage.setItem('token', token);
        setMessage('Регистрация завершена!');
        navigate('/dashboard');
      } else {
        const errData = await res.json();
        setMessage(JSON.stringify(errData));
      }
    } catch {
      setMessage('Ошибка при создании профиля');
    }
  };

  return (
    <form onSubmit={step === 1 ? handleRegister : step === 2 ? handleUpdateNames : handleCreateProfile}>
      <div className={s.wrapper}>
        <div className={s.registerBox}>
          <h2 className={s.title}>
            {step === 1 ? t('step1') : step === 2 ? t('step2') : t('step3')}
          </h2>

          <div className={s.inputGroup}>
            {step === 1 && (
              <>
                <label className={s.labelTop} htmlFor="username">{t('Username')}</label>
                <input name="username" placeholder={t('enterUsername')} value={formData.username} onChange={handleChange} required className={s.input} />

                <label className={s.labelTop} htmlFor="email">{t('Email')}</label>
                <input name="email" type="email" placeholder={t('enterEmail')} value={formData.email} onChange={handleChange} required className={s.input} />

                <label className={s.labelTop} htmlFor="password1">{t('Password')}</label>
                <input name="password1" type="password" placeholder={t('enterPassword')} value={formData.password1} onChange={handleChange} required className={s.input} />

                <label className={s.labelTop} htmlFor="password2">{t('repeatPassword')}</label>
                <input name="password2" type="password" placeholder={t('enterRepeatPass')} value={formData.password2} onChange={handleChange} required className={s.input} />
              </>
            )}

            {step === 2 && (
              <>
                <label className={s.labelTop} htmlFor="first_name">{t('FirstName')}</label>
                <input name="first_name" placeholder={t('enterFirstName')} value={formData.first_name} onChange={handleChange} required className={s.input} />

                <label className={s.labelTop} htmlFor="last_name">{t('LastName')}</label>
                <input name="last_name" placeholder={t('enterLastName')} value={formData.last_name} onChange={handleChange} required className={s.input} />
              </>
            )}

{step === 3 && (
  <>
    <label className={s.labelStep3}>
      <span>{t('Patronymic')}</span>
      <input name="otasining_ismi" placeholder={t('enterPatronymic')} value={formData.otasining_ismi} onChange={handleChange} className={s.input} />
    </label>

    <div className={s.labelStep3}>
      <span>{t('language')}</span>
      <select name="til" value={formData.til} onChange={handleChange} required className={s.inputStep3}>
        <option value="">{t('SelectLang')}</option>
        <option value="1">O'zbek tili</option>
        <option value="2">Русский язык</option>
        <option value="3">English</option>
      </select>
    </div>

    <div className={s.labelStep3}>
      <span>{t('AcadDegree')}</span>
      <select
        name="ilmiy_daraja"
        value={formData.ilmiy_daraja}
        onChange={handleChange}
        required
        className={s.inputStep3}
      >
        <option value="">{t('enterAcadDegree')}</option>
        {degrees.map(degree => {
          let name;
          switch (i18n.language) {
            case 'ru': name = degree.nomi_ru; break;
            case 'en': name = degree.nomi_en; break;
            default: name = degree.nomi_uz;
          }
          return (
            <option key={degree.id} value={degree.id}>
              {name}
            </option>
          );
        })}
      </select>
    </div>

    <div className={s.labelStep3}>
      <span>{t('about')}</span>
      <textarea name="description" placeholder={t('enterAbout')} value={formData.description} onChange={handleChange} className={s.input} />
    </div>

  </>
)}

          </div>
          <div className={s.buttonGroup}>
          {step === 3 && (
            <>
              <button
                type="button"
                className="register__btn btn__passive btn__skip"
                onClick={() => {
                  login({
                    token,
                    user: {
                      id: userId,
                      username: formData.username,
                      first_name: formData.first_name,
                      last_name: formData.last_name,
                      email: formData.email
                    }
                  });
                  localStorage.setItem('token', token);
                  setMessage('Регистрация завершена (без доп. данных).');
                  navigate('/dashboard');
                }}
              >
                {t('skip')}
              </button>
            </>
          )}
          </div>
          <div className={s.buttonGroup}>
            <button type="submit" className={s.loginBtn}>
              {step === 1 ? t('register') : step === 2 ? t('next2') : t('finish2')}
            </button>
            {step === 1 && <Link to="/login" className={s.registerBtn}>{t('login')}</Link>}
          </div>

          {message && <p className={s.message}>{message}</p>}
        </div>
      </div>
    </form>
  );
};
